import React, { forwardRef } from 'react';

import type { TextareaAutosizeProps } from '@mui/material';
import { TextareaAutosize } from '@mui/material';
import clsx from 'clsx';
import { useCommonTextareaStyles } from 'src/components/FormikAlineTextarea';

interface AlineTextareaProps extends TextareaAutosizeProps {
  dataCy?: string;
}

const Textarea = forwardRef(function AlineTextarea(
  props: AlineTextareaProps,
  ref: React.Ref<HTMLTextAreaElement>
): JSX.Element {
  const { className, dataCy, ...rest } = props;
  const { classes } = useCommonTextareaStyles({ disabled: rest.disabled });

  return (
    <TextareaAutosize
      className={clsx(className, classes.textArea)}
      data-cy={dataCy}
      {...rest}
      ref={ref}
    />
  );
});

export const AlineTextarea = React.memo(Textarea);
